import "./index.css";
import type { ICardProps } from "./types";
import { clsx } from "clsx";

export const Card = ({ children, variant, className, onClick }: ICardProps) => {
  const rootClass = clsx("nuco-card", `nuco-card--${variant}`, className);

  return (
    <div className={rootClass} onClick={onClick}>
      {children}
    </div>
  );
};
